<template>
  <div class="home">
    <div class="list">
      <div class="item">
        <div>分润合伙人总量</div>
        <b>{{data.appUser2Level}}</b>
      </div>
      <div class="item">
        <div>贡献合伙人总量</div>
        <b>{{data.appUser3Level}}</b>
      </div>
      <div class="item">
        <div>创业合伙人总量</div>
        <b>{{data.appUser4Level}}</b>
      </div>
      <div class="item">
        <div>今日新增会员</div>
        <b>{{data.newMembersToday}}</b>
      </div>
      <div class="item">
        <div>营业积分总量</div>
        <b>{{data.totalBusinessIntegral}}</b>
      </div>

      <div class="item">
        <div>现金钱包总量</div>
        <b>{{data.totalCashWallet}}</b>
      </div>
      <div class="item">
        <div>全网总贡献值</div>
        <b>{{data.totalContribution}}</b>
      </div>
      <div class="item">
        <div>购物抵扣金总量</div>
        <b>{{data.totalDiscountAmount}}</b>
      </div>
      <div class="item">
        <div>创业绩效分总量</div>
        <b>{{data.totalEntrepreneurialPerformanceScore}}</b>
      </div>
      <div class="item">
        <div>冻结积分总量</div>
        <b>{{data.totalFreezeIntegral}}</b>
      </div>

      <div class="item">
        <div>jkc总产出</div>
        <b>{{data.totalJkcOutPut}}</b>
      </div>
      <div class="item">
        <div>jkc支付总量</div>
        <b>{{data.totalJkcPayAmount}}</b>
      </div>
      <div class="item">
        <div>jkc支付总金额</div>
        <b>{{data.totalJkcPayAmountValue}}</b>
      </div>
      <div class="item">
        <div>jks总量</div>
        <b>{{data.totalJks}}</b>
      </div>
      <div class="item">
        <div>JKS当前价值</div>
        <b>{{data.totalJksValue}}</b>
      </div>

      <div class="item">
        <div>线下有效积分</div>
        <b>{{data.totalOffLineIntegral}}</b>
      </div>
      <div class="item">
        <div>线上有效积分</div>
        <b>{{data.totalOnLineIntegral}}</b>
      </div>
      <div class="item">
        <div>实体分红券总量</div>
        <b>{{data.totalPhysicalTicket}}</b>
      </div>
      <div class="item">
        <div>红利钱包总量</div>
        <b>{{data.totalWallet}}</b>
      </div>
      <div class="item">
        <div>红利金支付总金额</div>
        <b>{{data.totalWalletPayAmount}}</b>
      </div>
      <div class="item">
        <div>红利金提现总金额</div>
        <b>{{data.totalWalletWithdrawAmount}}</b>
      </div>
      <div class="item">
        <div>抵扣劵支出总金额</div>
        <b>{{data.totalDiscountPayAmount}}</b>
      </div>
      <div class="item">
        <div>昨日线下有效积分</div>
        <b>{{data.yesterdayOffLineIntegral}}</b>
      </div>
      <div class="item">
        <div>昨日线上有效积分</div>
        <b>{{data.yesterdayOnLineIntegral}}</b>
      </div>

    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      data: {},
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.httpGet('/admin/home/index').then((res) => {
        if (res.code == 200) {
					this.data = res.data
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .content-container {
  background: #f0f2f5 !important;
}
.home {
  width: 100%;
  height: calc(100vh - 130px);
  // background: #F0F2F5;
}
.list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  // &::after {
  //   content: '';
  //   width: 212px;
  // }
  box-sizing: border-box;
  padding: 15px;
  padding-top: 0;
  padding-left: 0;
  .item {
    margin-top: 15px;
    width: 212px;
    height: 100px;
    background: #ffffff;
    border-radius: 8px;
    margin-left: 15px;
    div {
      font-size: 14px;
      font-family: PingFangSC-Regular;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.45);
      margin-top: 21px;
      margin-left: 24px;
    }
    b {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 38px;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 20px;
      margin-left: 24px;
    }
  }
}
</style>

